const Airtable = require("airtable");

/**
  * Fetch Data from the Airtable Base
  * @params {string} baseName name of the Airtable base

  *  @returns {string} New Modified Date
*/
export function fetchDataFromBase(baseName) {
  const { VUE_APP_AIRTABLE_API_KEY, VUE_APP_BASE_ID } = process.env;

  const data = [];
  var base = new Airtable({ apiKey: VUE_APP_AIRTABLE_API_KEY }).base(
    VUE_APP_BASE_ID
  );

  base(baseName)
    .select({
      view: "Grid view",
    })
    .eachPage(
      function page(records, fetchNextPage) {
        records.forEach(function(record) {
          data.push(record.fields);
        });
        fetchNextPage();
      },
      function done(err) {
        if (err) {
          console.error(err);
          return;
        }
      }
    );
  return data;
}
